<template>
  <div class="wxMenu">
    <div class="title_text">自定义菜单</div>
    <div class="config_box">
      <!-- 左侧页面 -->
      <div class="left">
        <div class="wx_box">
          <div class="wx_title">公众号名称</div>
          <div class="wx_block"></div>
          <div class="wx_menu">
            <div class="keyboard">
              <img src="@/assets/images/keyboard.png" alt="">
            </div>
            <div class="menu_item" v-for="(item,index) in button" :key="index" :class="{showbd:item.selected}">
              <div v-if="item.addButton" style="color:#409eff;font-size:22px;font-weight:900" @click="addMenuItem()">+</div>
              <div v-else @click="selectItem(index)">{{item.name}}</div>
            </div>
          </div>
          <div class="sub_button">
            <div class="sub_button_box" v-for="(item,index) in button" :key="index">
              <div class="button_item" v-for="(btn,idx) in item.sub_button" :key="idx" :class="{showbd:btn.selected}">
                <div v-if="btn.addButton" style="color:#409eff;font-size:22px;font-weight:900" @click="addSubButtonItem(index)">+</div>
                <div v-else @click="selectSubButtonItem(index,idx)">{{btn.name}}</div>
              </div>
              <div class="arrow_box" v-if="!item.addButton"><i class="el-icon-caret-bottom arrow_icon"></i></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧配置 -->
      <div class="right">
        <div class="item_config" v-if="showConfig">
          <div class="title_line">
            <div style="flex:1">{{buttonItem.name}}</div>
            <div><el-button type="text" @click="delItem()">删除菜单</el-button></div>
          </div>
          <el-form label-width="110px" :model="buttonItem">
            <el-form-item label="菜单名称">
              <el-input :disabled="buttonItem.type == 'miniprogram'" class="input_box" size="small" v-model="buttonItem.name"></el-input>
              <div class="input_info">字数不超过5个汉字或16个字符</div>
            </el-form-item>
            <el-form-item label="菜单内容" v-if="buttonItem.type">
              <el-radio-group v-model="buttonItem.type">
                <el-radio label="view">跳转网页</el-radio>
                <el-radio label="miniprogram">跳转小程序</el-radio>
                <el-radio label="scancode_push">扫码功能</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="小程序" v-if="buttonItem.type == 'miniprogram'">
              <el-input disabled :value="mini_info.nick_name"></el-input>
            </el-form-item>
            <el-form-item label="跳转路径" v-if="buttonItem.type == 'miniprogram'">
              <el-select v-model="now_mini" placeholder="请选择" @change="set_mini_path">
                <el-option  v-for="item in miniArr" :key="item.name" :label="item.name" :value="item.pagepath">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="页面地址" v-if="buttonItem.type == 'view'">
              <el-input class="input_box" size="small" v-model="buttonItem.url" @blur="urlBlur"></el-input>
              <div class="input_info">粉丝点击该菜单会跳转到该链接</div>
              <div class="input_info">必填,必须是正确的URL格式</div>
              <div class="input_info">会员中心地址：{{centerUrl}}
                <el-button class="ml10" type="text" size="medium"
                  v-clipboard:copy="centerUrl"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError">复制</el-button>
              </div>
              <div class="input_info" v-for="(item,index) in linkLisk" :key="index">
                {{item.name}}：{{item.url}}
                <el-button class="ml10" type="text" size="medium"
                  v-clipboard:copy="linkLisk[index].url"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError">复制</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="button_box">
      <el-button type="primary" size="small" @click="save()">保存</el-button>
      <!-- <el-button type="primary" size="small">预览</el-button> -->
      <el-button type="primary" size="small" @click="delAll()">清空菜单</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GetMiniInfo } from "@/api/set";
import { mimiArr, mimiArr_2 } from "./init";
import { AddMenu, ClearMenu, GetMenu } from "@/api/configuration";

export default {
  computed: {
    ...mapGetters(["token", "app_id", "status"])
  },
  data() {
    return {
      button: [{ name: "", type: "", url: "", addButton: true }],
      buttonItem: {}, //右侧表单数据
      showConfig: false, //显示右侧内容
      buttonIndex: 0, //选择的底部菜单
      subButtonIndex: [0,0],  //选择的子菜单
      centerUrl: "https://jjtc.58zltc.com/vip?appid=",
      type: "1",
      linkLisk: [], //链接地址列表
      mini_info: {},
      miniArr: this.app_id == 432 ? mimiArr_2:mimiArr,
      now_mini: '',
      cai_status: ""
    }
  },
  mounted(){
    this.getData();
    this.getAppidInfo();
    this.centerUrl += this.app_id;
    this.linkLisk = [
      {name: "应用列表", url: "https://jjtc.58zltc.com/apply_change?appid="+this.app_id+"&list_code=101"},
      {name: "积分商城", url: "https://jjtc.58zltc.com/integralshop?appid="+this.app_id},
      {name: "油站导航", url: "https://jjtc.58zltc.com/vipShopList?appid="+this.app_id},
      {name: "充值有礼", url: "https://jjtc.58zltc.com/oilsCardList?appid="+this.app_id},
      {name: "车队卡", url: "https://jjtc.58zltc.com/carteamCard?appid="+this.app_id},
      {name: "亲属卡", url: "https://jjtc.58zltc.com/sendKinsCard?appid="+this.app_id},
      {name: "订单记录", url: "https://jjtc.58zltc.com/viporder?appid="+this.app_id},
      {name: "充值记录", url: "https://jjtc.58zltc.com/rechargelist?appid="+this.app_id},
      {name: "今日油价", url: "https://jjtc.58zltc.com/oil_price_show?appid="+this.app_id},
       
    ]
  },
  methods:{
    set_mini_path(value) {
      let obj = {};
      this.miniArr.map(item => {
        if (value == item.pagepath) {
          item.appid = this.mini_info.authorizer_appid;
          // console.log(this.mini_info.authorizer_appid)
          obj.selected = true;
          obj = item;
        }
      })
     this.buttonItem.name = obj.name;
     if (this.cai_status == 1) {
        this.button[this.buttonIndex] = obj;
        // this.addSubButtonItem(0);
        console.log(this.button)
     } else {
        let _one = this.subButtonIndex[0];
        let _two = this.subButtonIndex[1];
        console.log(this.button[0])
        this.button[_one].sub_button[_two] = obj;
     }
    },
    // 获取小程序信息
    async getAppidInfo() {
      try {
        const res = await GetMiniInfo({
          app_id: this.app_id
        });
        if (res.code == 200) {
          this.mini_info = res.data;
        }
      } catch (error) {
        console.log(error)
      }
    },
    getData(){
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      GetMenu(data).then(res=>{
        console.log(res)
        if(res.code == 200){
          if(res.data.button !== undefined){
            // this.button = res.data.button;
            this.button = [];
            res.data.button.forEach(item => {
              if(item.sub_button.length != 5){
                item.sub_button.push({name: "",type: "",url: "",addButton: true})
              }
              if(item.name){
                if(item.url !== undefined && item.url.split('?')[0] == 'https://jjtc.58zltc.com/wxScan'){
                  this.button.push({name:item.name, type:"scancode_push",sub_button:item.sub_button})
                }else{
                  this.button.push(item)
                }
              }
            })
            console.log(this.button);
            console.log(this.button.length)
            if(this.button.length != 3){
              this.button.push({name: "",type: "",url: "",addButton: true})
            }
          }
        }
        if(res.code == 404 && res.msg == "未授权"){
          this.$confirm('未授权应用无法编辑菜单，是否前往授权？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push({path:'/configuration/subScription/empower',query:{formHome:"1"}})
            var url = "https://www.58zltc.com/#/empower?appid=" + this.app_id;
            if(this.status == "test"){
              url = "https://www.58zltc.com/#/empower?appid=" + this.app_id;
            }
            window.location.href = url;
          }).catch();
        }
      })
    },
    addMenuItem(){  //添加底部菜单项
      var addbutton = this.button.pop();
      var url = ""
      this.button.push({ name:"新建菜单", type:"view", url: url, sub_button: [{name:"",type:"",url:"",addButton:true}], selected:true});
      this.buttonIndex = this.button.length-1;
      this.selectItem(this.buttonIndex);
      if(this.button.length < 3) {
        this.button.push(addbutton);
      }
    },
    selectItem(index){ //选中底部菜单项
      console.log(index);
      this.buttonIndex = index;
      this.button.forEach(item=>{
        item.selected = false;
        if(!item.addButton){
          item.sub_button.forEach(btn => {
            btn.selected = false
          })
        }
      })
      this.button[index].selected = true;
      this.buttonItem = this.button[index];
      this.showConfig = true;
      this.cai_status = 1;
    },
    delItem(){  //删除底部菜单项
      console.log(this.buttonIndex);
      if(this.buttonItem.sub_button){ //删除底部菜单
        this.buttonItem = {};
        this.showConfig = false;
        this.button.splice(this.buttonIndex,1);
        if(this.button.length == 2 && !this.button[1].addButton){
          this.button.push({name:"",type:"",url:"",addButton:true});
        }
      } else { //删除子菜单
        this.buttonItem = {};
        this.showConfig = false;
        this.button[this.subButtonIndex[0]].sub_button.splice(this.subButtonIndex[1],1);
        var ifAdd = this.button[this.subButtonIndex[0]].sub_button[this.button[this.subButtonIndex[0]].sub_button.length-1].addButton? true: false;
        if(this.button[this.subButtonIndex[0]].sub_button.length == 4 && !ifAdd){
          this.button[this.subButtonIndex[0]].sub_button.push({name:"",type:"",url:"",addButton: true})
        }
      }
      
    },
    addSubButtonItem(index){ //添加子菜单项
      console.log(this.button[index].sub_button)
      this.button.forEach(item=>{
        item.selected = false;
        if(!item.addButton){
          item.sub_button.forEach(btn => {
            btn.selected = false
          })
        }
      })
      this.button[index].type = "";
      var addbutton = this.button[index].sub_button.pop();
      this.button[index].sub_button.push({name:"新建菜单",type:"view",url:"",selected:true})
      this.subButtonIndex = [index,this.button[index].sub_button.length-1]
      this.buttonItem = this.button[index].sub_button[this.subButtonIndex[1]]
      if(this.button[index].sub_button.length < 5) {
        this.button[index].sub_button.push(addbutton);
      }
    },
     //选中子菜单项
    selectSubButtonItem(index,idx) {
      console.log(index,idx)
      this.cai_status = 2;
      this.subButtonIndex = [index,idx];
      this.button.forEach(item=>{
        item.selected = false;
        if(!item.addButton){
          item.sub_button.forEach(btn => {
            btn.selected = false
          })
        }
      })
      this.button[index].sub_button[idx].selected = true;
      this.buttonItem = this.button[index].sub_button[idx];
      this.showConfig = true;
    },
    CHECK_URL(url) {
      //url= 协议://(ftp的登录信息)[IP|域名](:端口号)(/或?请求参数)
      var strRegex = '^((https|http|ftp)://)?'//(https或http或ftp):// 可有可无
        + '(([\\w_!~*\'()\\.&=+$%-]+: )?[\\w_!~*\'()\\.&=+$%-]+@)?' //ftp的user@  可有可无
        + '(([0-9]{1,3}\\.){3}[0-9]{1,3}' // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
        + '|' // 允许IP和DOMAIN（域名） 
        + '(localhost)|'	//匹配localhost
        + '([\\w_!~*\'()-]+\\.)*' // 域名- 至少一个[英文或数字_!~*\'()-]加上.
        + '\\w+\\.' // 一级域名 -英文或数字  加上.
        + '[a-zA-Z]{1,6})' // 顶级域名- 1-6位英文 
        + '(:[0-9]{1,5})?' // 端口- :80 ,1-5位数字
        + '((/?)|' // url无参数结尾 - 斜杆或这没有
        + '(/[\\w_!~*\'()\\.;?:@&=+$,%#-]+)+/?)$'; //请求参数结尾- 英文或数字和[]内的各种字符
          
          var strRegex1 = '^(?=^.{3,255}$)((http|https|ftp)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/)?(?:\/(.+)\/?$)?(\/\w+\.\w+)*([\?&]\w+=\w*|[\u4e00-\u9fa5]+)*$';
      var re=new RegExp(strRegex,'i');//i不区分大小写
      console.log(re);
      //将url做uri转码后再匹配，解除请求参数中的中文和空字符影响
      if (re.test(encodeURI(url))) {
        return (true);
      } else {
        return (false);
      }
    },
    onCopy(){
      this.$message({
        type: "success",
        message: "复制成功"
      })
    },
    onError(){
      this.$message({
        type: "error",
        message: "复制失败，请手动选择复制"
      })
    },
    urlBlur(e){
      if(!this.CHECK_URL(this.buttonItem.url)){
        this.$message({
          type:"error",
          message:"url路径不合法！"
        })
      }
    },
    save(){
      var myButton = [];
      console.log(this.button)
      this.button.forEach(item=>{
        delete item.selected;
        if(item.addButton){
        }else if(item.type == 'view'){ //是跳转链接按钮
          var vi = Object.assign({},item)
          vi.sub_button = [];
          myButton.push(vi);
        } else if(item.type == 'scancode_push'){ //是扫码按钮
          var i = Object.assign({},item);
          i.type = "view";
          i.url = "https://jjtc.58zltc.com/wxScan?appid="+this.app_id
          i.sub_button = [];
          myButton.push(i);
        } else if(item.type == 'miniprogram'){ // 小程序
          var vii = Object.assign({}, item);
          vii.sub_button = [];
          myButton.push(vii);
        } else if(item.sub_button.length > 1) {
          var subButton = [];
          item.sub_button.forEach(sub=> {
            delete sub.selected;
            if(sub.addButton){
              //是添加按钮
            }else if(sub.type == "view"){
              subButton.push(sub);
            }else if(sub.type == "scancode_push"){
              var ai = Object.assign({},sub)
              ai.type = "view";
              ai.url = "https://jjtc.58zltc.com/wxScan?appid="+this.app_id;
              subButton.push(ai);
            } else if (sub.type == "miniprogram"){ //小程序
              subButton.push(sub);
            } 
          })
          delete item.type;
          delete item.url;
          console.log("sub_button", item,item.name)
          var si = {
            name: item.name,
            sub_button: subButton
          }
          myButton.push(si)
        }
      })
      var data = {
        token: this.token,
        app_id: this.app_id,
        menu: {
          button: myButton
        }
      }
      console.log(myButton)
      // return false;
      AddMenu(data).then(res=>{
        if(res.code == 200){
          this.$message({
            type: "success",
            message: "保存成功"
          })
          this.getData()
        }else{
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      })
    },
    delAll(){
      this.$confirm('清空菜单无法恢复，确认清空？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          token: this.token,
          app_id: this.app_id
        }
        ClearMenu(data).then(res=>{
          if(res.code == 200){
            this.button = [{name:"",type:"",url:""}];
          }
        })
      }).catch();
    }
  }
}
</script>
<style lang="scss" scoped>
.wxMenu{
  overflow: auto;
  .title_text{
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    margin-top: 20px;
    height: 65px;
    line-height: 65px;
  }
  .config_box{
    width: 1050px;
    margin: 0 auto;
    border: 1px solid #dee5e7;
    display: flex;
    .left{
      padding: 30px 36px;
      border-right: 1px solid #dee5e7;
      .wx_box{
        width:308px;
        border: 1px solid #ddd;
        position: relative;
        .wx_title{
          background: #323232;
          color: #fff;
          height: 45px;
          line-height: 45px;
          text-align: center;
          font-size: 15px;
        }
        .wx_block{
          height: 414px;
          background: #efefef;
        }
        .wx_menu{
          background: #fff;
          display: flex;
          border-top: 1px solid #ddd;
          height: 50px;
          .keyboard{
            padding-top: 16px;
            padding-left: 10px;
            width:40px;
          }
          .menu_item{
            border-left: 1px solid #ddd;
            flex:1;
            height: 100%;
            line-height: 50px;
            font-size: 14px;
            text-align: center;
          }
          .showbd{
            border: 1px solid #409eff;
          }
        }
        .sub_button{
          position: absolute;
          bottom: 47px;
          left: 40px;
          width:266px;
          display: flex;
          .sub_button_box{
            flex:1;
            text-align: center;
            margin: 0 5px;
            padding-bottom: 11px;
            position: relative;
            height: auto;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            .showbd{
              border: 1px solid #409eff !important;
            }
            .button_item{
              border: 1px solid #ddd;
              height: 40px;
              width: 100%;
              line-height: 40px;
              background: #fff;
            }
            .arrow_box{
              position: absolute;
              bottom: 0px;
              text-align: center;
              width:100%;
            }
            .arrow_icon{
              color: #fff;
              font-size: 16px;
            }
          }
        }
      }
    }
    .right{
      flex:1;
      .item_config{
        .title_line{
          border-bottom: 1px solid #ddd;
          height: 50px;
          line-height: 50px;
          padding: 0 18px;
          display: flex;
          margin-bottom:20px;
        }
      }
      .input_box{
        width:260px;
      }
      .input_info{
        color: #999;
        height: 20px;
      }
    }
  }
  .button_box{
    margin-top:20px;
    text-align: center;
  }
}
</style>